module.exports = __webpack_public_path__ + "img/applicationClenaing2x.bda77015.png";